import { useEffect, useState } from 'react';
import clsx from 'clsx';

import DropDown from '../Dropdown';
import Radio from '../Radio';
export interface SectionProps {
  questions: any;
  questionVisibility: any;
  formik?: any;
  handleChange?: (fieldName: string, value: string) => void;
  handleDynamicQuestionPatch?: () => void;
}

function Section({
  questions,
  questionVisibility,
  formik,
  handleChange,
  handleDynamicQuestionPatch,
}: Readonly<SectionProps>) {
  const [qVisibility, setQVisibility] = useState<any>({});

  const handleNextQuestion = (fieldName: string, answer: any) => {
    const values = {
      ...formik.values,
      [fieldName]: answer,
    };
    localStorage.setItem('qFlowInPageForm', JSON.stringify(values));
    handleDynamicQuestionPatch?.();
  };

  const handleOnClick = (fieldName: string, value: any) => {
    handleChange?.(fieldName, value);
    handleNextQuestion(fieldName, value);
  };

  useEffect(() => {
    setQVisibility(questionVisibility);
  }, [questionVisibility]);

  return (
    <form data-testid="in-page-questions-secion">
      {questions && (
        <div className="relative rounded-xl dark:bg-slate-800/25">
          <div className="rounded-xl">
            <div className="w-full py-2">
              {Object.keys(questions).map((key: any) => {
                return (
                  <div
                    id={key}
                    data-testid={key}
                    key={`question-${key}`}
                    className={clsx(
                      'relative',
                      qVisibility[key] ? 'block' : 'hidden'
                    )}
                  >
                    {questions[key].singlechoice &&
                      questions[key].singlechoice.popularcount > 0 && (
                        <Radio
                          title={questions[key].title}
                          options={questions[key].options}
                          fieldName={key}
                          itemsPerRow={questions[key].annotations.numberOfRows}
                          handleChange={handleOnClick}
                          formik={formik}
                        />
                      )}

                    {questions[key].type === 'radio' && (
                      <Radio
                        title={questions[key].title}
                        options={questions[key].options}
                        fieldName={key}
                        itemsPerRow={questions[key].annotations.numberOfRows}
                        handleChange={handleOnClick}
                        formik={formik}
                      />
                    )}
                    {questions[key].type === 'singlechoice' &&
                      questions[key].singlechoice && (
                        <div className="mt-3">
                          <DropDown
                            title={
                              questions[key].singlechoice.popularcount > 0
                                ? ''
                                : questions[key].title
                            }
                            placeholder={questions[key].placeholder}
                            options={questions[key]?.singlechoice?.choices}
                            fieldName={key}
                            formik={formik}
                            handleChange={handleOnClick}
                          />
                        </div>
                      )}
                  </div>
                );
              })}
            </div>
          </div>
        </div>
      )}
    </form>
  );
}

export default Section;
